import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const ContactListDetails = () => {
    const columns = [
      { label: 'Name', value: 'name' },
      { label: 'Email', value: 'email' },
      { label: 'Phone', value: 'phone' },
      { label: 'Company', value: 'company' },
      { label: 'Created At', value: (item) => fmtDateTime(item.created_at) },
      {
        label: 'Access Details',
        value: (contactId) => (
          <button onClick={() => handleAccessDetails(contactId)}>Access Details</button>
        ),
      },
    ];

    const handleAccessDetails = (contactId) => {
      // Handle access details action
      //console.log('Access Details', contactId);
      const encodedId = btoa(contactId);
      window.location.href = `/contact/details/${encodedId}`;
    };

    return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES.contact} pageTitle="Contacts" />;
  };

export default ContactListDetails